Date.prototype.yyyymmdd = function () {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
  var dd = this.getDate().toString();
  return yyyy + (mm[1] ? mm : "0" + mm[0]) + (dd[1] ? dd : "0" + dd[0]); // padding
};
Date.prototype.yyyymmdddash = function () {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
  var dd = this.getDate().toString();
  return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]); // padding
};
Date.prototype.toNetworkDate = function () {
  var yyyy = this.getFullYear().toString();
  var mm = (this.getMonth() + 1).toString(); // getMonth() is zero-based
  var dd = this.getDate().toString();
  return yyyy + "-" + (mm[1] ? mm : "0" + mm[0]) + "-" + (dd[1] ? dd : "0" + dd[0]); // padding
};
Date.prototype.hhmm = function () {
  return this.toISOString().slice(11, 16);
};
Date.prototype.withTime = function (time) {
  var a = this;
  return new Date(a.getFullYear(), a.getMonth(), a.getDate(), time.getHours(), time.getMinutes(), 0);
};
Date.prototype.addMinutes = function (minutes) {
  return new Date(this + minutes * 60000);
};
Date.prototype.toShortDateString = function () {
  return this.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit'
  });
};
String.prototype.parseyyyymmdd = function () {
  if (!/^(\d){8}$/.test(this)) return "invalid date";
  var y = this.substr(0, 4),
    m = this.substr(4, 2) - 1,
    d = this.substr(6, 2);
  return new Date(y, m, d);
};
var app = angular.module('leanlaw');
app.run(['$rootScope', '$state', 'tracking', function ($rootScope, $state, tracking) {
  // This allows adding 'redirectTo' and 'redirectParams' to the state definitions
  $rootScope.$on('$stateChangeStart', function (evt, to, params) {
    if (to.redirectTo) {
      evt.preventDefault();
      $state.go(to.redirectTo, to.redirectParams || params);
    }
  });
}]);
app.animation(".enter-slide", function () {
  return {
    setup: function (element) {
      element.hide();
    },
    start: function (element, done, memo) {
      try {
        element.slideDown(function () {
          done();
        });
      } catch (ex) {}
    }
  };
});
angular.module('leanlaw').animation(".leave-slide", function () {
  return {
    start: function (element, done, memo) {
      element.slideUp(function () {
        done();
      });
    }
  };
});
angular.module('leanlaw').animation('.quick-client-form', function () {
  return {
    beforeAddClass: function (element, className, done) {
      if (className == 'ng-hide') {
        jQuery(element).animate({
          opacity: 0
        }, done);
      } else {
        done();
      }
    },
    removeClass: function (element, className, done) {
      if (className == 'ng-hide') {
        element.css('opacity', 0);
        jQuery(element).animate({
          opacity: 1
        }, done);
      } else {
        done();
      }
    }
  };
});